import React, { useState, useEffect, useCallback } from 'react';
import { Layout } from '../components/Layout';
import { Card, CardContent, CardHeader, CardTitle } from '../components/ui/card';
import { BarChart, Bar, XAxis, YAxis, CartesianGrid, Tooltip, ResponsiveContainer } from 'recharts';
import { useLanguage } from '../contexts/LanguageContext';
import axios from 'axios';

const API = process.env.REACT_APP_BACKEND_URL;
const MONTHS = ['Jan','Fev','Mar','Avr','Mai','Jun','Jul','Aou','Sep','Oct','Nov','Dec'];

export default function DesignerDashboard() {
  const { t } = useLanguage();
  const [stats, setStats] = useState(null);

  const fetchData = useCallback(async () => {
    try {
      const res = await axios.get(`${API}/api/designs/stats`, { withCredentials: true });
      setStats(res.data);
    } catch (e) { console.error(e); }
  }, []);

  useEffect(() => { fetchData(); }, [fetchData]);

  const chartData = stats?.monthly_designs?.map(m => ({ name: MONTHS[m.month - 1], designs: m.count })) || [];

  return (
    <Layout>
      <div className="space-y-6">
        <h1 className="text-2xl font-semibold text-slate-900">{t('nav_dashboard')}</h1>
        {stats && (
          <>
            <div className="grid grid-cols-1 md:grid-cols-3 gap-4">
              <Card className="border-slate-200 shadow-sm">
                <CardHeader className="pb-2"><CardTitle className="text-sm text-slate-500">{t('month_earnings')}</CardTitle></CardHeader>
                <CardContent><p className="text-2xl font-bold text-emerald-700">{(stats.month_earnings_vnd || 0).toLocaleString()} VND</p></CardContent>
              </Card>
              <Card className="border-slate-200 shadow-sm">
                <CardHeader className="pb-2"><CardTitle className="text-sm text-slate-500">{t('prev_month_earnings')}</CardTitle></CardHeader>
                <CardContent><p className="text-2xl font-bold text-slate-700">{(stats.prev_month_earnings_vnd || 0).toLocaleString()} VND</p></CardContent>
              </Card>
              <Card className="border-slate-200 shadow-sm">
                <CardHeader className="pb-2"><CardTitle className="text-sm text-slate-500">{t('year_earnings')}</CardTitle></CardHeader>
                <CardContent><p className="text-2xl font-bold text-blue-700">{(stats.year_earnings_vnd || 0).toLocaleString()} VND</p></CardContent>
              </Card>
            </div>
            <Card className="border-slate-200 shadow-sm">
              <CardHeader><CardTitle className="text-base">{t('designs_per_month')}</CardTitle></CardHeader>
              <CardContent>
                <ResponsiveContainer width="100%" height={300}>
                  <BarChart data={chartData}>
                    <CartesianGrid strokeDasharray="3 3" stroke="#e2e8f0" />
                    <XAxis dataKey="name" tick={{ fontSize: 12 }} />
                    <YAxis allowDecimals={false} tick={{ fontSize: 12 }} />
                    <Tooltip />
                    <Bar dataKey="designs" fill="#1e293b" radius={[4, 4, 0, 0]} />
                  </BarChart>
                </ResponsiveContainer>
              </CardContent>
            </Card>
          </>
        )}
      </div>
    </Layout>
  );
}
